import { ReviewHighLightsSection } from '@src/quince-components/src'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'

import ProductPageSectionProps from '../../../domains/ProductPageSectionProps'

function ReviewHighlights(props: ProductPageSectionProps | BundlePageSectionProps) {
  const product = 'bundle' in props ? props.bundle : props.product
  if (!product.productReviews || product.productReviews.length === 0) return null

  return (
    <ReviewHighLightsSection
      highLights={product.productReviews.slice(0, 4).map(vr => ({
        avgRating: vr?.rating,
        title: vr?.title || '',
        children: vr?.body || '',
        brandName: vr?.reviewTags?.filter(x => x.tags === 'EXTERNAL_BRAND_NAME')?.[0]?.tagValues?.join(', '),
      }))}
      product={product}
    />
  )
}

export default ReviewHighlights
